import logoAnimated from 'Assets/Icons/logo-animated.svg';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import styles from './NotFoundPage.module.sass';

export const NotFoundPage = () => {
    return (
        <PageTemplate>
            <Helmet>
                <title>Pagina niet gevonden - App Growing People B.V.</title>
            </Helmet>

            <div className={styles.container}>
                <img src={logoAnimated} width="300px" alt='logo' />

                <div className={styles.message_container}>
                    <div className={styles.message}>Pagina niet gevonden.</div>
                </div>
            </div>
        </PageTemplate>
    )
}